import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import {
    ClearFamilyTrailData, ResetFamilyTrailData, SetCreateUpdate, SetCurrentFocusLevel, SetFamilyTrailData,
    SetFamilyTreeNodeData,
    SetFamilyView,
    SetFamilyVisitedProfile,
    SetFocusedTrailData,
    SetTrailHistory,
    SetTrailLevelChangeHistory
} from './family-tree.actions';
import {
    ICurrentFocusLevel, IFamilyTreeNode, IFamilyTreeTrail,
    ITrailHistory, ITrailLevelChangeHistory
} from 'src/app/common/models/IFamilyTreeTrail';


export class FamilyTreeStateModel {
    familyTrail: IFamilyTreeTrail[];
    focusedTrail: IFamilyTreeTrail;
    data: IFamilyTreeNode;
    visitedProfile: boolean;
    createUpdate: string;
    familyView: number;
    trailHistory: ITrailHistory;
    trailLevelChangeHistory: ITrailLevelChangeHistory;
    currentFocusLevel: ICurrentFocusLevel;
}

@State<FamilyTreeStateModel>({
    name: 'FamilTreeSettings',
    defaults: {
        familyTrail: [],
        focusedTrail: null,
        data: null,
        visitedProfile: false,
        createUpdate: null,
        familyView: 1,
        trailHistory: {},
        trailLevelChangeHistory: {},
        currentFocusLevel: {}
    }
})

@Injectable()
export class FamilyTreeState {

    @Selector()
    static getFamilyDataState(state: FamilyTreeStateModel) {
        return state;
    }

    @Action(SetFamilyTrailData)
    public setFamilyTrail({ getState, setState }: StateContext<FamilyTreeStateModel>,
        { familyTrail }: SetFamilyTrailData) {
        const state = getState();
        setState({ ...state, familyTrail });
    }

    @Selector()
    static getFamilyTrail(state: FamilyTreeStateModel) {
        return state.familyTrail;
    }

    @Selector()
    static getFocusedTrailDataState(state: FamilyTreeStateModel) {
        return state.focusedTrail;
    }

    @Action(SetFocusedTrailData)
    public setFocusedData({ getState, setState }: StateContext<FamilyTreeStateModel>,
        { focusedTrail }: SetFocusedTrailData) {
        const state = getState();
        setState({ ...state, focusedTrail });
    }

    @Selector()
    static getFocusedDataState(state: FamilyTreeStateModel) {
        return state.focusedTrail;
    }

    @Action(SetFamilyTreeNodeData)
    public setFamilyTreeNodeData({ getState, setState }: StateContext<FamilyTreeStateModel>,
        { data }: SetFamilyTreeNodeData) {
        const state = getState();
        setState({ ...state, data });
    }

    @Action(SetFamilyVisitedProfile)
    public setFamilyVisitedProfile({ getState, setState }: StateContext<FamilyTreeStateModel>,
        { visitedProfile }: SetFamilyVisitedProfile) {
        const state = getState();
        setState({ ...state, visitedProfile });
    }

    @Selector()
    static getFamilyVisitedProfileState(state: FamilyTreeStateModel) {
        return state.visitedProfile;
    }

    @Action(SetCreateUpdate)
    public setCreateUpdate({ getState, setState }: StateContext<FamilyTreeStateModel>,
        { createUpdate }: SetCreateUpdate) {
        const state = getState();
        setState({ ...state, createUpdate });
    }

    @Selector()
    static getCreateUpdateState(state: FamilyTreeStateModel) {
        return state.createUpdate;
    }

    @Action(SetFamilyView)
    public setFamilyView({ getState, setState }: StateContext<FamilyTreeStateModel>,
        { familyView }: SetFamilyView) {
        const state = getState();
        setState({ ...state, familyView });
    }

    @Selector()
    static getFamilySelectedView(state: FamilyTreeStateModel) {
        return state.familyView;
    }

    @Action(SetTrailHistory)
    public setTrailHistory({ getState, setState }: StateContext<FamilyTreeStateModel>,
        { trailHistory }: SetTrailHistory) {
        const state = getState();
        setState({ ...state, trailHistory });
    }

    @Selector()
    static getTrailHistory(state: FamilyTreeStateModel) {
        return state.trailHistory;
    }

    @Action(SetTrailLevelChangeHistory)
    public setTrailLevelChangeHistory({ getState, setState }: StateContext<FamilyTreeStateModel>,
        { trailLevelChangeHistory }: SetTrailLevelChangeHistory) {
        const state = getState();
        setState({ ...state, trailLevelChangeHistory });
    }

    @Selector()
    static getTrailLevelChangeHistory(state: FamilyTreeStateModel) {
        return state.trailLevelChangeHistory;
    }

    @Action(SetCurrentFocusLevel)
    public setCurrentFocusLevel({ getState, setState }: StateContext<FamilyTreeStateModel>,
        { currentFocusLevel }: SetCurrentFocusLevel) {
        const state = getState();
        setState({ ...state, currentFocusLevel });
    }

    @Selector()
    static getCurrentFocusLevel(state: FamilyTreeStateModel) {
        return state.currentFocusLevel;
    }

    @Action(ResetFamilyTrailData)
    public resetFamilyTrailData({ getState, setState }: StateContext<FamilyTreeStateModel>) {
        const state = getState();
        setState({
            ...state, trailHistory: {}, trailLevelChangeHistory: {}, currentFocusLevel: {}
        });
    }

    @Action(ClearFamilyTrailData)
    public clearFamilyTrail({ getState, setState }: StateContext<FamilyTreeStateModel>) {
        const state = getState();
        setState({
            ...state, familyTrail: [], focusedTrail: null, data: null, visitedProfile: false,
            createUpdate: null, familyView: 1, trailHistory: {}, trailLevelChangeHistory: {}, currentFocusLevel: {}
        });
    }
}
